<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 class="pt-10">
        <h1>Almost done! Pending email confirmation...</h1>
        <p
          class="mt-8"
        >Thank you for subscribing to The Outdoor Wire Digital Network's newsletter(s). We have sent a confirmation email to your inbox. Please do the following:</p>
        <ul class="mx-4">
          <li>Find the confirmation email in your inbox</li>
          <li>Click on the confirmation link in the email body</li>
          <li>Enjoy reading your newsletter(s)!</li>
        </ul>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "pendingConfirmation",
};
</script>
